import { ReactElement } from "react";
import styled from "styled-components";

const MainContainer = styled.div`
  padding: 50px 20px 120px 20px;
  height: 100%;
`;

const Main = ({children}:{children: ReactElement | ReactElement[]}) => (
  <MainContainer>
      {children}
  </MainContainer>
); 

export default Main;